import React ,{useEffect} from 'react';
import AOS from 'aos';
import Container from '../Components/Pages/Terms/Container';
import Header from '../Components/Shared/Header/Header';
import Footer from '../Components/Shared/Footer/Footer';
function Terms(){
    useEffect(() => {
        AOS.init({
          duration: 800,
          disable: 'mobile',
          once: true,
        });
      }, []);
    return(
        <>
        <Header styles="scrolled"/>
        <Container />
        <Footer />
        </>
    )
};
export default Terms ;